if (!customElements.get('popover-text')) {
  class PopoverText extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      document.addEventListener('popover:open', this.onTrigger.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('popover:open', this.onTrigger);
    }

    onTrigger(event) {
      if (event.detail.id === this.getAttribute('popover-id')) {
        this.open();
        setTimeout(() => {
          this.close();
        }, 3000);
      }
    }

    open() {
      this.setAttribute('open', true);
    }

    close() {
      this.removeAttribute('open');
    }
  }
  customElements.define('popover-text', PopoverText);
}
